module.exports = __webpack_public_path__ + "img/certification11.f69c987e.png";